export const state = () => ({
    isConnected: false,
    socket: null,
    user: null,
    expires: null,
    lang: null,
    token: null,
  });
  
  export const mutations = {
    SET_LOGGED_USER(state, payload) {
      localStorage.removeItem("user");
      localStorage.setItem("user", payload);
      state.user = payload;
    },
    SET_EXPIRES_TOKEN(state, payload) {
      localStorage.removeItem("expires");
      localStorage.setItem("expires", payload);
      state.expires = payload;
    },
    SET_LANGUAGE(state, payload) {
      localStorage.removeItem("lang");
      localStorage.setItem("lang", payload);
      state.lang = payload;
    },
    SET_CURRENT_TOKEN(state, payload) {
      localStorage.removeItem("token");
      localStorage.setItem("token", payload);
      state.token = payload;
    },
    SOCKET_CONNECT(state) {
      state.isConnected = true;
    },
    SOCKET_DISCONNECT(state) {
      state.isConnected = false;
    },
    SOCKET_INSTANCE(state, socket) {
      state.socket = socket;
    },
  };
  
  export const getters = {
    get_socket: (state) => {
      return state.socket;
    },
  };
  
  export const actions = {};
  